import { Injectable } from '@angular/core';
import { ListMetadata } from 'app/models/list-metadata.model';
import { Observable } from 'rxjs';
import { HttpClientService } from '../httpClient/httpclient.service';
import { JsonSchema, JsonSchemaFormPropertiesForm, AuditRuleObject } from 'app/views/audit/models/audit-event.model';

@Injectable()
export class RulesService {
  //info conosciute a priori
  formNames = {
    infoBase: "form.infobase",
    condition: "form.condition",
    action: "form.action"
  }

  //info conosciute a priori
  infoBaseFieldsName = {
    rule_type: "rule_type",
    event_source: "event_source",
    rule_challenge_detail: "rule_challenge_detail",
    rule_challenge: "rule_challenge",
    rule_description: "rule_description",
    rule_start: "rule_start",
    rule_end: "rule_end",
    cluster: "cluster",
    acm: "acm",
    acm_active_range: "acm_active_range",
    acm_min: "acm_min",
    acm_max: "acm_max",
    cinfo_nominativo: "cinfo_nominativo",
    cinfo_blacklist: "cinfo_blacklist",
    cinfo_newsletter: "cinfo_newsletter",
    cinfo_recapiti: "cinfo_recapiti",
    cinfo_privacy: "cinfo_privacy"
  }

  //info conosciute a priori
  conditionFieldsName = {
    cluster: "cluster",
    acm: "acm",
    acm_min: "acm_min",
    acm_reason: "acm_reason",
    channel_condition: "channel_condition",
    source_system: "source_system",
    condition_notes: "condition_notes",
    condition_code: "condition_code",
    acm_val: "acm_val",
    condition_description: "condition_description",
    acm_max: "acm_max",
    acm_range: "acm_range",
    acm_value: "acm_value",
    touchpoint: "touchpoint",
    condition_type: "condition_type",
    condition_source: "condition_source",
    acm_comparison_operator: "acm_comparison_operator",
    cluster_boolean_condition: "cluster_boolean_condition"

  }

  actionFieldsName = {
    cluster: "cluster",
    cluster_start: "cluster_start",
    cluster_end: "cluster_end",
    cluster_add: "cluster_add",
    cluster_delete: "cluster_delete",
    acm: "acm",
    acm_val: "acm_val",
    acm_reason: "acm_reason",
    amazon: "amazon",
    kafka: "kafka",
    magnews: "magnews",
    kncRest: "kncRest",
    push: "push",
    challenge_id: "challenge_id",
    challenge_description: "challenge_description",
    start_date: "start_date",
    end_date: "end_date"
  }


  baseUrl = '/k7o/event';

  constructor(private http: HttpClientService) { }

  list(
    offset = null,
    limit = null,
    search?: any,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {

    if (!sort) {
      sort = "id"
      sort_dir = -1;
    }

let searchArray: any[] = search ? [...search] : [];

    if (search) {
      const ruleTypeFilter = searchArray.find(f => f.key === 'auditRulesTypeId');
      const flgDeployFilter = searchArray.find(f => f.key === 'flgDeploy');
      const flgDeploy = flgDeployFilter ? flgDeployFilter.value : null;

      if (flgDeploy === '0') {
        searchArray.push({ key: 'flgState', value: '0' });
      } else if (flgDeploy === '1') {
        searchArray.push({ key: 'flgState', value: '3' });
        searchArray = searchArray.filter(f => f.key !== 'flgDeploy');
        searchArray.push({ key: 'flgDeploy', value: '0' });
      } else if (flgDeploy === '2') {
        searchArray.push({ key: 'flgState', value: '1' });
        searchArray = searchArray.filter(f => f.key !== 'flgDeploy');
        searchArray.push({ key: 'flgDeploy', value: '0' });
      }
    }

    const params = HttpClientService.buildListParams(offset, limit, searchArray, globalSearch, sort, sort_dir);
    searchArray.splice(0, searchArray.length);
    return this.http.getPaged(this.baseUrl + '/audit_rule/list' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }

  getPreparedFormSchemasRules(resSchemaBE) {
    if (resSchemaBE) {

      let mainForm = resSchemaBE.form_def;
      let jsonSchema = new JsonSchema();
      jsonSchema.title = mainForm["title"];
      jsonSchema.description = mainForm["description"];
      jsonSchema.type = mainForm["type"];

      //inizializzazione schema form dei vari tab
      jsonSchema.properties.infoBase = this.getPreparedFormSchema(jsonSchema, mainForm, "infoBase", this.infoBaseFieldsName);
      //  jsonSchema.properties.condition = this.getPreparedFormSchema(jsonSchema,mainForm,"condition",this.conditionFieldsName);

      return jsonSchema;

    }
  }
  getPreparedFormSchemasConditions(resSchemaBE) {
    if (resSchemaBE) {

      let mainForm = resSchemaBE.form_def;
      let jsonSchema = new JsonSchema();
      jsonSchema.title = mainForm["title"];
      jsonSchema.description = mainForm["description"];
      jsonSchema.type = mainForm["type"];

      //inizializzazione schema form dell'ultimo tab
      jsonSchema.properties.condition = this.getPreparedFormSchema(jsonSchema, mainForm, "condition", this.conditionFieldsName);

      return jsonSchema;

    }
  }
  getPreparedFormSchemasActions(resSchemaBE) {
    if (resSchemaBE) {

      let mainForm = resSchemaBE.form_def;
      let jsonSchema = new JsonSchema();
      jsonSchema.title = mainForm["title"];
      jsonSchema.description = mainForm["description"];
      jsonSchema.type = mainForm["type"];
      //inizializzazione schema form dell'ultimo tab
      jsonSchema.properties.action = this.getPreparedFormSchema(jsonSchema, mainForm, "action", this.actionFieldsName);

      return jsonSchema;

    }
  }
  getPreparedFormSchema(jsonSchema: JsonSchema, resSchemaBE: any, nameFieldForm: string, fieldsName: any): JsonSchemaFormPropertiesForm {
    const level1 = resSchemaBE.properties[this.formNames[nameFieldForm]];
    jsonSchema.properties[nameFieldForm].formName = this.formNames[nameFieldForm]; // conosciuto a priori
    jsonSchema.properties[nameFieldForm].id = level1.id;
    jsonSchema.properties[nameFieldForm].description = level1.description;

    for (let name in fieldsName) {
      const fieldProperties = resSchemaBE.properties[this.formNames[nameFieldForm]].properties[fieldsName[name]];
      const arrayRequired = level1.required ? level1.required : [];
      const arrayDisabled = level1.disabled ? level1.disabled : [];
      const arrayHidden = level1.hidden ? level1.hidden : [];

      if (fieldProperties) {
        jsonSchema.properties[nameFieldForm].form[name] = {};
        jsonSchema.properties[nameFieldForm].form[name]["id"] = fieldProperties.id;
        jsonSchema.properties[nameFieldForm].form[name]["description"] = fieldProperties.description;
        jsonSchema.properties[nameFieldForm].form[name]["fieldName"] = name;
        jsonSchema.properties[nameFieldForm].form[name]["step"] = fieldProperties.step ? +fieldProperties.step : null;
        jsonSchema.properties[nameFieldForm].form[name]["maxLength"] = fieldProperties.maxLength ? +fieldProperties.maxLength : null;
        jsonSchema.properties[nameFieldForm].form[name]["minLength"] = fieldProperties.minLength ? +fieldProperties.minLength : null;
        jsonSchema.properties[nameFieldForm].form[name]["minValue"] = fieldProperties.minValue ? Number.parseFloat(fieldProperties.minValue) : null;
        jsonSchema.properties[nameFieldForm].form[name]["maxValue"] = fieldProperties.maxValue ? Number.parseFloat(fieldProperties.maxValue) : null;
        jsonSchema.properties[nameFieldForm].form[name]["default"] = fieldProperties.default ? fieldProperties.default : null;
        jsonSchema.properties[nameFieldForm].form[name]["pattern"] = fieldProperties.pattern ? fieldProperties.pattern : null;
        jsonSchema.properties[nameFieldForm].form[name]["type"] = fieldProperties.type ? fieldProperties.type : null;
        jsonSchema.properties[nameFieldForm].form[name]["required"] = arrayRequired.includes(fieldsName[name]);
        jsonSchema.properties[nameFieldForm].form[name]["disabled"] = arrayDisabled.includes(fieldsName[name]);
        jsonSchema.properties[nameFieldForm].form[name]["radioOptions"] = fieldProperties.radioOptions;
        jsonSchema.properties[nameFieldForm].form[name]["options"] = fieldProperties.options ? fieldProperties.options : null;
        jsonSchema.properties[nameFieldForm].form[name]["filterable"] = fieldProperties.filterable ? fieldProperties.filterable : null;

        jsonSchema.properties[nameFieldForm].form[name]["visible"] = arrayHidden.includes(fieldsName[name]) ? false : true;

        if (fieldProperties.label) {
          jsonSchema.properties[nameFieldForm].form[name]["label"] = {};
          jsonSchema.properties[nameFieldForm].form[name].label["it"] = fieldProperties.label.it ? fieldProperties.label.it : null;
          jsonSchema.properties[nameFieldForm].form[name].label["en"] = fieldProperties.label.it ? fieldProperties.label.en : null;
        }
      }
    }

    return jsonSchema.properties[nameFieldForm];
  }

  getJsonFormSchema(entity: string, modeType: string, assigned_to_id?: any) {
    return this.http.get(this.baseUrl + "/audit_template_assignement?assignementEntity=" + entity + "&assignementType=" + modeType + "&assignedToId=" + assigned_to_id);

  }

  getJsonFormSchemaList() {
    return this.http.get(this.baseUrl + "/audit_template_assignement/list");

  }

  getActionRulesTypeList() {

    return this.http.get(this.baseUrl + "/audit_rules_type/list");
  }

  getActionTypeList() {

    return this.http.get(this.baseUrl + "/audit_action_type/list");
  }

  getConditionTypeList() {

    return this.http.get(this.baseUrl + "/audit_rules_condition_type/list");
  }

  getTemplateById(id: number) {

    return this.http.get(this.baseUrl + "/audit_template/" + id);
  }
  getTemplateList() {

    return this.http.get(this.baseUrl + "/audit_template/list");
  }

  ui_modes = {
    CREATE: "create",
    EDIT: "update"
  }

  schema_modes = {
    CREATE: "create",
    EDIT: "edit"
  }

  saveAuditRuleGlobalObject(auditRuleObject: AuditRuleObject) {
    return this.http.post(`${this.baseUrl}/audit_rule/createGlobal`, auditRuleObject).map(res => {
      return res;
    }).catch(error => Observable.throw(error));
  }

  updateAuditRuleGlobalObject(auditRuleObject: AuditRuleObject) {
    return this.http.put(`${this.baseUrl}/audit_rule/updateGlobal/` + auditRuleObject.rule.id, auditRuleObject).map(res => {
      return res;
    }).catch(error => Observable.throw(error));
  }

  getAuditRuleId(id: number) {

    return this.http.get(this.baseUrl + "/audit_rule/" + id);
  }

  getActionExternalList(auditRulesTypeId: number) {

    return this.http.get(this.baseUrl + "/audit_action_external/" + auditRulesTypeId + "/list");
  }

  getAuditRuleGlobalObject(auditRuleId: number) {

    return this.http.get(this.baseUrl + "/audit_rule/retrieveGlobal/" + auditRuleId);
  }

  deleteAuditRule(auditRuleId: number) {
    return this.http.delete(this.baseUrl + "/audit_rule/" + auditRuleId);

  }

  recoverAuditRule(auditRuleId: number) {
    return this.http.put(this.baseUrl + "/audit_rule/" + auditRuleId + "/recover", null);

  }

  linkUnlinkAuditRule(auditRuleId: number) {
    return this.http.put(this.baseUrl + "/audit_rule/" + auditRuleId + "/switch", null)

  }
}



// WEBPACK FOOTER //
// ./src/app/services/audit/rules.service.ts